import React from "react";
import {Box, Divider, Typography} from "@mui/material";
import ImportCsvColumnAutocomplete from "../../../text-fields/autocomplete/import-csv-column-autocomplete";

const ColumnMappingRow = ({
                              field,
                              columns,
                              required,
                          }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            alignItems: {xs: 'stretch', md: 'flex-start'},
            justifyContent: 'space-between',
            gap: 1,
            py: 1,
        }}
    >
        <Typography
            variant={'body2'}
            fontWeight={600}
            color={'primary.main'}
            sx={{
                minWidth: 0,
                wordBreak: 'break-word',
                pt: 1,
            }}
        >
            {field.title}
        </Typography>
        <Divider
            orientation={'horizontal'}
            flexItem
            variant={'fullWidth'}
            sx={{
                flexGrow: 1,
                alignSelf: 'center',
                marginInline: 1,
                borderStyle: 'dashed',
                borderColor: 'text.secondary',
                display: {xs: 'none', md: 'block'},
            }}
        />
        <ImportCsvColumnAutocomplete
            form
            name={field.name}
            label={field.title}
            required={required}
            columns={columns}
            optional={field.optional}
            textFieldProps={{variant: 'outlined', size: 'small'}}
            sx={{
                flex: '0 1 50%',
                minWidth: 0,
                maxWidth: {xs: '100%', md: '50%'},
            }}
        />
    </Box>
);

export default ColumnMappingRow;
